/*
 * Copyright (C) 2017 Spanning Cloud Apps LLC.  All rights reserved.
 */
import './metadataCompareDiffModal.tpl.html';

/**
 * Module for the metadata compare diff modal.
 */
angular
  .module('shared.metadataCompareDiffModal', [])
  /**
   * Metadata compare diff controller.  Controller for the metadataCompareDiffModal.tpl.html template.
   */
  .controller(
    'MetadataDiffModalCtrl',
    function (
      $scope,
      $uibModalInstance,
      $filter,
      $timeout,
      $rootScope,
      $window,
      httpMetadataCompare,
      METADATA_COMPARE_STATE,
      ALERT_EVENTS,
      fileInfo
    ) {
      var diff2htmlUi;

      $scope.fileType = {
        RIGHT: 1,
        LEFT: 2
      };

      // header text is passed through from the parent since we dont have
      // batch info here.
      $scope.leftHeader = fileInfo.leftHeader || '';
      $scope.rightHeader = fileInfo.rightHeader || '';

      $scope.fileName = fileInfo.leftFileName || fileInfo.rightFileName;
      $scope.hasLeftFile = !!fileInfo.leftFileName;
      $scope.hasRightFile = !!fileInfo.rightFileName;
      $scope.isMatch = fileInfo.state === METADATA_COMPARE_STATE.EQUAL;
      $scope.hasBinaryData = !!fileInfo.hasBinaryData;
      $scope.exportInProgress = false;
      $scope.showLoadingMask = false;
      $scope.isLargeFile = fileInfo.isLargeFile;

      if (!$scope.isMatch && !$scope.isLargeFile) {
        $scope.showLoadingMask = true;

        httpMetadataCompare.getMetadataDiff(fileInfo.urlToDiff).then(
          function (diffString) {
            // need to wait until modal has rendered so we can actually get the #url-diff-container element
            $timeout(function () {
              const target = document.getElementById('url-diff-container');
              const config = {
                outputFormat: 'side-by-side',
                drawFileList: false,
                matching: 'lines',
                synchronisedScroll: true,
                fileContentToggle: false
              };

              diff2htmlUi = new Diff2HtmlUI(target, diffString, config);
              diff2htmlUi.draw();

              $scope.showLoadingMask = false;
            }, 500);
          },
          function () {
            // if error, hide mask
            $scope.showLoadingMask = false;
          }
        );
      }

      /**
       * Function to export file.
       */
      $scope.exportFile = function (fileType) {
        var sfOrgIdForKey = fileType === $scope.fileType.RIGHT ? fileInfo.rightSfOrgId : fileInfo.leftSfOrgId;

        $scope.exportInProgress = true;

        httpMetadataCompare.getMetadataExportUrl(fileInfo.id, fileType, sfOrgIdForKey).then(
          function (res) {
            var url = res ? res.url : '';

            $window.location.href = url;

            $scope.exportInProgress = false;
          },
          function () {
            $rootScope.$emit(ALERT_EVENTS.ERROR.eventName, $filter('i18n')('EXPORT_METADATA_ERROR'));
            $scope.exportInProgress = false;
          }
        );
      };

      /**
       * Function to cancel out of the model.
       */
      $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
      };
    }
  );
